import * as React from "react";
import {Component} from "react";
import {Field, Form, getFormValues, reduxForm} from "redux-form";
import styles from "../../../styles/forms/superadmin/add_product_attribute_template_group_wizard/AddProductAttributeTemplateGroupForm.scss";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import {__, mapStateToProps, setTableParams} from "../../../core/utils";
import {withRouter} from "react-router";
import autobind from "autobind-decorator";
import ButtonGroup from "../../../components/ButtonGroup";
import {subscribe} from "react-contextual";
import Localization from "../../../helpers/Localization";

@withRouter
@reduxForm({form: "superadmin.add_product_attribute_template_group_wizard.add_product_attribute_template_group"})
@mapStateToProps(state => ({
    values: getFormValues("superadmin.add_product_attribute_template_group_wizard.add_product_attribute_template_group")(state),
    auth: state.auth,
}))
@subscribe(Localization, "localization")
class AddProductAttributeTemplateGroupForm extends Component {
    @autobind
    _handleSubmit(edit) {
        this.props.change('edit', edit);

        setTimeout(() => this.props.submit(), 10);
    }

    render() {
        const languages = _.transform(_.filter(this.props.localization.languages, ['application_language', 1]), (languages, language) => {
            languages[language.id] = language.id == 1;
        }, {});

        return (
            <Form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
                <div className={styles.form}>
                    <Field name="name" component={Input} label="Name" localized={languages} />
                    <Field name="priority" component={Input} label="Priority" numeric />
                </div>
                <div className={styles.footer}>
                    <Button lightGray medium left middleText={__('button.cancel')} onClick={() => setTableParams('superadmin_product_attribute_template_groups', {
                        add_product_attribute_template_group_wizard: undefined
                    })} />
                    <ButtonGroup>
                        <Button lightBlue medium middleText={__('button.create')} spinning={this.props.submitting} onClick={() => this._handleSubmit(false)} />
                        <Button lightBlue medium middleText={__('button.create-edit')} spinning={this.props.submitting} onClick={() => this._handleSubmit(true)} />
                    </ButtonGroup>
                </div>
            </Form>
        );
    }
}

export default AddProductAttributeTemplateGroupForm;
